import { Loader2 } from 'lucide-react';
import React from 'react';

function Loader(props) {
    return (
        <div className='flex h-dvh justify-center items-center'>
            <Loader2
                className='animate-spin'
                size={20}
            />
        </div>
    );
}

export default Loader;